<template>
    <el-container class='main-body'>
      <el-aside class='main-menu' width="130px">
        <nav-menu></nav-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
</template>
<script>
  import navMenu from '@/components/nav-menu'
  export default {
    components: { navMenu }
  }
</script>



// WEBPACK FOOTER //
// src/views/index.vue